export default __webpack_public_path__ + "static/media/coffee-Mug.6f5b6d08.jpg";